export default {
    responsible: 'Responsible',
    control: 'Control',
    controlDomain: 'Control domain',
    treatmentAction: 'Treatment action',
    controlAction: 'Control action',
    controlsTitle: 'Controls of impact area',
    forAsset: 'For the asset',
    noControls: 'There are no controls associated with this impact area.',
    controlDescription: 'Description of the treatment action',
    minCharsHint: 'Minimum {min} characters',
    followUpDate: 'Next follow up',
    creationDate: 'Creation date',
    noControl: 'The control does not exist',
    noControlsPage: 'There are no controls to show, add controls to your risks to follow them up from here.',
    noControlAction: 'The control action does not exist',
    noControlActions: 'There are no control actions',
    noResponsible: 'The responsible does not exist',
    noResponsibles: 'There are no responsibles',
    controlMonitoring: 'Control monitoring',
    associatingControl: 'Associating control...',
    confirmControlAssociationLowRisk: 'For this risk level it is not necessary to implement a control, are you sure you want to associate one?',
    confirmDeleteControl: 'Are you sure you want to delete the control? This action cannot be undone.',
    deletingControl: 'Deleting control...',
    deleteControlError: 'An error occurred while deleting the control:',
    controlDeleted: 'Control deleted successfully',
    controlStatus: 'Control status',
    controlFollowUpDate: 'Follow up date',
    nextControlFollowUpDate: 'Next follow up date',
    followDescription: 'Follow description',
    followParticipants: 'Follow participants',
    selectParticipant: 'Select participant',
    addEnterParticipant: 'Press Enter to add a new participant',
    noParticipant: 'The participant does not exist. Press Enter to add it.',
    noParticipants: 'There are no participants',
    addEvidences: 'Attach evidence',
    endFollows: 'End follow ups to this control',
    controlGeneralDescription: 'Control description',
    createNewFollowUp: 'Creating new follow up to the control',
    noFollowUpsForControl: 'It seems that there are no follow-ups for this control yet.',
    confirmDeleteFollowUp: 'Are you sure you want to delete this follow-up? This will permanently remove a traceability record.',
    deletingFollowUp: 'Deleting follow up...',
    deleteFollowUpError: 'Error deleting follow up',
    followUpDeleted: 'Follow up deleted successfully',
    loadingFollowUpInfo: 'Loading follow up information...',
    fetchFollowUpError: 'An error occurred while querying the follow up',
    selectTreatmentAction: 'Select a treatment action',
    noTreatmentAction: 'No treatment action exists',
    noTreatmentActions: 'No treatment actions',
    noControlDomain: 'No control domain exists',
    noControlDomains: 'No control domains',
    evidences: 'Evidences',
    explainAcceptanceOrTransfer: "Briefly explain the reason for accepting or transferring the risk.",
    controlSavedSuccess: 'Control saved succesfuly',


};
